import Block from "components/layout/block";
import { Fragment } from "react";
import SharedForm from "./shared-form";
import { useList } from "stores/hooks/list";
import Line from "components/layout/line";
import PDFForm from "./pdf-form";

const ReportingTab = () => {
  const list = useList();

  if (!list) {
    return null;
  }

  return (
    <Fragment>
      <Block title="Luettelon julkinen jako">
        <SharedForm list={list} />
      </Block>
      <Line />
      <Block title="Luo PDF-raportti">
        <PDFForm list={list} />
      </Block>
    </Fragment>
  );
};

export default ReportingTab;
